<template>
  <el-container style="padding: 10px 20px">
    <el-main width="600px">
      <el-form :inline="true" ref="form" label-width="90px">
        <template slot="title">
          <div>
            <span style="display: block; margin-bottom: 10px">
              <i class="el-icon-s-tools"></i>
              绑定设备
            </span>
          </div>
        </template>
        <el-radio label="1">限制登录(启用后，非绑定设备不能登录系统)</el-radio>
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 10px"
          tooltip-effect="dark"
        >
          <el-table-column prop="slotname" label="设备类型"></el-table-column>
          <el-table-column
            prop="slotedition"
            label="设备识别号"
          ></el-table-column>
          <el-table-column prop="slotedition" label="状态"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small">解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-link :underline="false" style="margin-top: 10px; float: right"
          >列表为过去24小时登录过的设备及已绑定的设备</el-link
        >
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  inject: ['app'],
  props: {
    dialogVisible: {
      type: Boolean,
    },
  },
  computed: {
    selfDialogVisible() {
      return this.dialogVisible
    },
  },
  data() {
    return {
      tableData: [
        { slotname: 'LDAP', slotedition: '***********' },
        { slotname: '微信', slotedition: 'v0.08' },
        { slotname: 'QQ', slotedition: 'v0.01' },
      ],
      imageUrl: '',
      labelPosition: 'left',
      activeName: '1',
      nowUserInfo: {},
      userBox: [],
      extraText: '',
      imageUrls: '',
      msg: {},
      phone: '',
    }
  },
  created() {
    let res = JSON.parse(localStorage.getItem('authInfo'))
    this.nowUserInfo = res.accountInfo
    this.getUserInfo()
  },
  mounted() {},
  methods: {
    getUserInfo() {
      this.$http
        .get(
          '/sitir-tavern-service/tavern/account/get-keycloak-account-detail-by-id',
          {
            params: {
              id: this.nowUserInfo.id,
            },
          }
        )
        .then((res) => {})
    },
    filechange(file, fileList) {
      console.log(file.raw)
      this.imageUrl = file.raw.path
      this.imageUrls = file.raw
    },
    handleRemove() {
      this.imageUrl = ''
    },
    onSubmit(params) {
      const form = new FormData()
      form.append('file', this.imageUrls)
      form.append('keycloakId', this.nowUserInfo.id)
      form.append('adminNote', this.userBox.adminNote)
      form.append('aliasName', this.userBox.aliasName)
      form.append('phone', this.phone)
      const authInfo = JSON.parse(window.localStorage.authInfo)
      let url =
        '/sitir-tavern-service/tavern/account/edit-account-keycloak-extra-info'
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + authInfo.token,
        },
      }
      this.$http.post(url, form, config).then((res) => {
        console.log(res)
        if (res.status === 200) {
          this.$message('修改成功！')
          this.getUserInfo()
        } else {
          this.$message('错误' + res.data.message)
        }
      })
    },
    resetForm() {
      this.$refs.userInfo.resetFields()
    },
    toHome() {
      this.$emit('updateDialogVisible')
    },
    beforeClose() {
      this.toHome()
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
